import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { SizePane } from 'page/ProfileScreen/SizeSlider/SizePane'
import { isMax } from 'page/ProfileScreen/SizeSlider/SizeSlider'
import { store } from 'store/store'

export const ChestSlider = observer(() => {
  const form = store.profile.form
  const { min, max } = store.profile.form.cfg.dimensions.chest
  const value = form.chest
  const plus = isMax(value, max)
  const label = form.male ? i18n('Chest') : i18n('Bust')

  const onChange = useLatestCallback((value: number) => {
    form.setChest(value)
  })

  return <SizePane label={label} value={value} plus={plus}
    min={min} max={max} onChange={onChange} />
})
